<template>
    <transition-group name="fade-table" class="custom-table">
        <div class="progress" v-if="loading" key="progress">
            <div
                class="progress-bar progress-bar-striped progress-bar-animated"
                role="progressbar"
                aria-valuenow="100"
                aria-valuemin="0"
                aria-valuemax="100"
                style="width: 100%"
            />
        </div>

        <div class="row" v-if="realPaginator && realPaginator.data && realPaginator.data.length" key="data">
            <div class="col-lg-12 mr-auto pt-6">
                <div class="card-deck mb-5" v-for="index in rows" :key="`deck-${index}`" mode="out-in">
                    <div
                        class="card rounded-lg overflow-hidden hvr-float w-100 w-md-auto mb-5 mb-md-0"
                        v-for="item in realPaginator.data.slice(index * columns - columns, index * columns)"
                        :key="`item-${item.id}`"
                    >
                        <slot v-bind:item="item" name="card" />
                    </div>
                </div>
            </div>
        </div>

        <div class="pt-6 text-center" v-else-if="!loading" key="no-items">
            <i class="fa fa-folder-open text-primary  d-block" style="font-size: 15rem;" />
            <h4 class="text-muted mt-3">We could not find any results.</h4>
        </div>

        <div class="paginator" key="paginator" v-if="showPaginator">
            <vue-paginator :page="realPaginator" v-on:retrieve-page="$emit('retrieve-page', $event)" />
        </div>
    </transition-group>
</template>

<script>
    import Vue from 'vue';

    import VuePaginator from '@components/paginator';

    export default Vue.extend({
        components: {
            VuePaginator
        },
        props: {
            paginator: Object,
            data: Array,
            loading: {
                type: Boolean,
                default: false
            },
            columns: {
                type: Number,
                default: 3
            },
            rows: {
                type: Number,
                default: 2
            }
        },
        data() {
            return {
                realPaginator: this.paginator,
                requestData: true
            };
        },
        watch: {
            paginator: {
                immediate: true,
                deep: true,
                handler() {
                    this.realPaginator = this.paginator;
                }
            },
            data: {
                immediate: true,
                deep: true,
                handler() {
                    if (!this.data || !this.data.length) {
                        return;
                    }

                    this.requestData = false;
                    this.realPaginator = {};

                    Object.assign(this.realPaginator, {
                        current_page: 1,
                        data: this.data,
                        last_page: Math.floor(this.data.length / this.rows / this.columns),
                        total: this.data.length
                    });
                }
            }
        },
        computed: {
            showPaginator() {
                if (!this.realPaginator) {
                    return false;
                }

                return (
                    this.realPaginator.current_page > 1 ||
                    this.realPaginator.current_page < this.realPaginator.last_page
                );
            }
        }
    });
</script>
